import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { proofMetrics } from "../../data/mock";

export const Proof = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section id="work" className="relative">
      <div className="max-w-[1180px] mx-auto px-5 md:px-10">
        <div className="h-px bg-[rgba(10,10,10,0.08)]" />
      </div>

      <div
        ref={ref}
        className={`max-w-[920px] mx-auto px-5 md:px-10 py-[60px] md:py-[80px] lg:py-[120px] transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h2 className="text-[clamp(26px,4vw,40px)] font-semibold leading-[1.2] tracking-tight text-[#0A0A0A] mb-14">
          Impact, Not Impressions.
        </h2>

        <div>
          {proofMetrics.map((metric, index) => (
            <div key={index}>
              {index > 0 && (
                <div className="h-px bg-[rgba(10,10,10,0.08)]" />
              )}
              <div className="py-6">
                <p className="text-[clamp(16px,2vw,18px)] leading-[1.65] text-[rgba(10,10,10,0.6)]">
                  {metric}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-[clamp(16px,2vw,18px)] leading-[1.6] text-[#0A0A0A] font-medium">
          We measure thinking by results.
        </p>
      </div>
    </section>
  );
};
